<!--设备管理-场地管理 列表-->
<template>
  <div >
    <TitleCard :titleMsg1="titleMsg1" :titleMsg2="titleMsg2" :titleMsg3="titleMsg3"></TitleCard>

    <a-modal v-model="geoshow"  >
      <MapGeo :keyWord="address"></MapGeo>
    </a-modal>

    <a-card class="all-card-style " >

<!--      搜索模块-->
      <div class="search-box">
        <a-form layout="inline" >

          <a-form-item
            label="内容"  class="ant-form-item2 "
          >
            <a-input
              placeholder="请输入" v-model="searchkey"
            >
            </a-input>
          </a-form-item>

          <a-form-item>
            <a-button type="primary" @click="handlePageList" html-type="button" >
              查询
            </a-button>
          </a-form-item>
        </a-form>
      </div>

      <!--      列表表格-->
      <div>
        <a-button type="primary" html-type="button" @click="toAddPage">
          新增
        </a-button>
        <a-table :columns="columns" :data-source="datalist" >

          <span slot="action" style="width:300px;" slot-scope="text, record">
            <a @click="toEditPage(record)">修改</a>
            <a-divider type="vertical"/>
            <a @click="showDeleteModal(record)">删除</a>
              <a-divider type="vertical"/>
            <a @click="toEditSceneMap(record)">场景图</a>
          </span>
        </a-table>
      </div>
    </a-card>

    <!--              弹出框-->
    <a-modal v-model="deleteModalVisible" title="删除" @ok="handleDelete" ok-text="确认" cancel-text="取消">
      <p>是否删除</p>
    </a-modal>

  </div>
</template>



<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'

  import MapGeo from '@/components/MapGeo.vue'



  export default {
    name: 'seedingList',
    components: {
      TitleCard,
      MapGeo
    },
    data() {
      return {
        titleMsg1:"设备管理",
        titleMsg2:'场地管理',
        titleMsg3:'场地管理',
        geoshow:false,
        datalist:[],
        columns: [

          {
            title: '场地编码',
            dataIndex: 'cSceneCode',
            key: 'cSceneCode',
            ellipsis: true,
          },
          {
            title: '场地名称',
            dataIndex: 'cSceneName',
            key: 'cSceneName',
            ellipsis: true,
          },


          {
            title: '纬度',
            dataIndex: 'cLatitude',
            key: 'cLatitude',
            ellipsis: true,
          },
          {
            title: '经度',
            dataIndex: 'cLongitude',
            key: 'cLongitude',
            ellipsis: true,
          },
          {
            title: '地址',
            dataIndex: 'cAddress',
            key: 'cAddress',
            ellipsis: true

          },
          {
            title: '单位',
            dataIndex: 'cUnit',
            key: 'cUnit',
            ellipsis: true,
          },
          {
            title: '负责人',
            dataIndex: 'cChargeUser',
            key: 'cChargeUser',
            ellipsis: true,
          },
          {
            title: '负责人手机',
            dataIndex: 'cChargeMoblie',
            key: 'cChargeMoblie',
            ellipsis: true,
          },
          {
            title: '创建时间',
            dataIndex: 'dCreateDate',
            key: 'dCreateDate',
            ellipsis: true,
          },
          {
            title: '备注',
            dataIndex: 'Remark',
            key: 'Remark',
            ellipsis: true,
          },
          {
            title: '操作',
            key: 'action',
            width:170,
            scopedSlots: { customRender: 'action' },
          },
        ],
        record:{},
        searchkey: "",
        cPlatformID:"",
        address:'',
        deleteModalVisible:false
      }
    },
    mounted () {
      let that=this;

    try{  that.cPlatformID=that.$store.getters.PlatForm.ID;}catch (e) {}

      that.handlePageList();
      this.$bus.$on('platformchange',(target)=> {
        that.cPlatformID=target.id;
        that.handlePageList();
      });

    },
    beforeDestroy () {
      this.$bus.$off('platformchange');
    },
    methods:{

      //列表
      async handlePageList(){


        let that=this;


        let param={cSystemCode:'设施园艺',keyword:that.searchkey,cPlatformID:that.cPlatformID,cEntID:that.$store.getters.User.enterprise.ID};

        let res= await that.$http.post('EntSceneInfo/List',param)

        if(res.data.code=="200"){

          that.datalist= res.data.obj.list;

        }
        else{
          that.$message.error(res.message)

        }
      },

      //删除
      async handleDelete(){
        let that=this;
        let param=null;
        let res=await that.$http.post('EntSceneInfo/Delete?ids='+that.record.ID,param)


        if(res.data.code=="200"){
          this.deleteModalVisible=false;
          that.$message.success(res.data.message)
          that.handlePageList();
        }
        else{
          that.$message.error(res.message)

        }
      },
      //查询经纬度
      toMapPage(record){
        let that=this;
        that.geoshow=true;

        that.address=record.cAddress;
      },
      //新增
      toAddPage(){
        let that=this;
        this.$router.push({name:'SceneManagementForm',params:{cPlatformID:that.cPlatformID}});

      },
      //修改
      toEditPage(obj){
        let that=this;
        this.$router.push({name:'SceneManagementForm',params:{ID:obj.ID,cPlatformID:that.cPlatformID}});
      },
      toEditSceneMap(obj){
        let that=this;
        this.$router.push({name:'SceneManagementMapForm',params:{ID:obj.ID,cPlatformID:that.cPlatformID}});
      },
      showDeleteModal:function (obj) {
        this.record=obj;
        this.deleteModalVisible=true;
      },


    }
  }
</script>
